module.exports = __webpack_public_path__ + "web/img/img2.6c37dc17.png";